module.exports = __webpack_public_path__ + "d3fe4fcb93f504f8c6253bee3bd7bebb.png";